<template>
  <div class="col-lg-4 col-md-12 box-col-4">
    <div class="card sell-card">
      <div class="card-header pb-0">
        <div class="d-flex justify-content-between">
          <div class="flex-grow-1">
            <p class="square-after f-w-600 header-text-success">
              Total de Pedidos en el mes<i class="fa fa-circle"> </i>
            </p>
            <h4>{{ formattedTotalPedidos }}</h4>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="profit-wrapper header-text-success icon-bg-success">
              <i :class="trendIconClass"></i>
            </div>
            <h6 class="header-text-success">{{ formattedTrendPercentage }}</h6>
            <p class="mb-0">{{ trendLabel }}</p>
          </div>
        </div>
        <div class="right-side icon-right-success">
          <i class="fa fa-shopping-basket"></i>
          <div class="shap-block">
            <div class="rounded-shap animate-bg-secondary"><i></i><i></i></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SellCard',
  props: {
    totalPedidos: {
      type: Number,
      default: 0,
    },
    trendPercentage: {
      type: Number,
      default: 0,
    },
    trendLabel: {
      type: String,
      default: 'Se ve muy bien',
    },
  },
  computed: {
    formattedTotalPedidos() {
      const value = Number(this.totalPedidos) || 0
      return value.toLocaleString('es-MX')
    },
    formattedTrendPercentage() {
      const value = Number(this.trendPercentage)
      if (Number.isFinite(value)) {
        return `${value.toFixed(2)}%`
      }
      return '0.00%'
    },
    trendIconClass() {
      const value = Number(this.trendPercentage) || 0
      return value < 0 ? 'fa fa-arrow-right' : 'fa fa-arrow-up'
    },
  },
}
</script>
